exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".collapsible-container{padding:16px 16px 2px;border:1px solid #ececf1;border-radius:12px;gap:12px;display:flex;flex-direction:column}.collapsible-container .c-header{display:flex;flex-direction:row;justify-content:space-between;align-items:center;gap:12px}.collapsible-container .c-content{padding-bottom:16px}.collapsible-container .c-title{color:#132056;font-size:14px;line-height:22px;font-weight:600}.collapsible-container .c-icon-open{transform:rotate(180deg);transition:transform ease 250ms}.collapsible-container .c-icon-close{transition:transform ease 250ms}", ""]);

// exports
